import React, { Component } from 'react';
import PropTypes from 'prop-types';

import EmailReportConfigApi from 'apis/EmailReportConfig';
import Toaster from 'components/Toaster';
import BusinessApi from 'apis/Business';

import ListSmsConfigs from './ListSmsConfigs';

class SmsAlertConfigList extends Component {
  constructor() {
    super();
    this.state = {
      configs: [],
    };
  }

  componentDidMount() {
    this.fetchConfig();
  }

  fetchConfig = () => {
    const { businessId } = this.props;
    if (businessId) return this.getBusinessEmailReportConfig(businessId);
  };

  getBusinessEmailReportConfig = businessId => {
    BusinessApi.getBusinessSmsConfig(businessId)
      .then(({ data }) => {
        this.setState({ configs: data });
      })
      .catch(error => {
        Toaster.getFailureToaster(
          error,
          'exclamation-triangle',
          'Connection Error'
        );
      });
  };

  render() {
    const { configs } = this.state;

    return (
      <div>
        <p>
          Text/SMS Alerts help you stay on top of your survey results through
          SMS notifications.
          <br />
          You can select and customize the types of alerts you would like to
          receive below.
        </p>
        <ListSmsConfigs
          configs={configs}
          toggleEditConfig={this.toggleEditConfig}
        />
      </div>
    );
  }
}

SmsAlertConfigList.defaultProps = {
  businessId: null,
};

SmsAlertConfigList.propTypes = {
  businessId: PropTypes.string,
};

export default SmsAlertConfigList;



// WEBPACK FOOTER //
// ./src/components/emailConfig/list/SmsAlertConfigList.js